import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getForgotPasswordEmailSentPath = () => urlHelper(`/forgot-password/email-sent`);
